document.addEventListener("DOMContentLoaded", () => {

  const slider = document.querySelector(".gr__slider");
  if (!slider) return;

  const track = slider.querySelector(".gr__track");
  const cards = [...track.children];
  const prevBtn = slider.querySelector(".gr__nav--prev");
  const nextBtn = slider.querySelector(".gr__nav--next");
  const dots = document.querySelectorAll(".gr__dot");

  let current = 0;
  let auto;

  function cardsPerView() {
    if (window.innerWidth < 768) return 1;
    if (window.innerWidth < 990) return 2;
    return 3;
  }

  function totalPages() {
    return Math.ceil(cards.length / cardsPerView());
  }

  function updateSlider() {

  const perView = cardsPerView();

  const gap =
    window.innerWidth < 768 ? 0 :
    window.innerWidth < 990 ? 20 : 25;

  const cardWidth = cards[0].offsetWidth + gap;

  track.style.transform =
    `translateX(-${current * cardWidth * perView}px)`;

  dots.forEach((dot, i) => {
    dot.classList.toggle("is-active", i === current);
  });
  
  }

  function nextSlide() {
    current++;
    if (current >= totalPages()) current = 0;
    updateSlider();
  }

  function prevSlide() {
    current--;
    if (current < 0) current = totalPages() - 1;
    updateSlider();
  }

  nextBtn.addEventListener("click", () => {
    nextSlide();
    restartAuto();
  });

  prevBtn.addEventListener("click", () => {
    prevSlide();
    restartAuto();
  });

  dots.forEach((dot, index) => {
    dot.addEventListener("click", () => {
      current = index;
      updateSlider();
      restartAuto();
    });
  });

  function startAuto() {
    auto = setInterval(nextSlide, 5000);
  }

  function restartAuto() {
    clearInterval(auto);
    startAuto();
  }

  slider.addEventListener("mouseenter", () => clearInterval(auto));
  slider.addEventListener("mouseleave", startAuto);

  window.addEventListener("resize", () => {
    current = 0;
    updateSlider();
  });

  updateSlider();
  startAuto();

});